var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableClassBefore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    transform: "translate(14 12) rotate(180)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0l7,12H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7 1.984635353088379 L 1.741037368774414 11 L 12.25896263122559 11 L 7 1.984635353088379 M 7 0 L 14 12 L 0 12 L 7 0 Z",
    stroke: "none",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableClassBefore);
export default __webpack_public_path__ + "static/media/table-class-before.95ac461a5fd3c97b22cdd323e8ed17b4.svg";
export { ForwardRef as ReactComponent };